import React, { useRef } from "react";
import Home from "./Home";
import Footer from "./Footer";
import SolutionsAndChallenges from "./Solutions&Challenges";
import OurImpact from "./our impact";
import TrustedPartners from "./TrustedPartners";
import CTASection from "./CTASection";

const MainLayout = () => {
  const homeRef = useRef(null);
  const solutionsChallengesRef = useRef(null);

  return (
    <>
      <Home ref={homeRef} />
      <div className="App">
        <SolutionsAndChallenges ref={solutionsChallengesRef} />
      </div>
      <OurImpact />
      <TrustedPartners />
      <CTASection />
      <Footer />
    </>
  );
};

export default MainLayout;
